//@flow
import * as Immutable from 'immutable';

import { Team } from 'common/models/flow/Team';

import type { TeamModelType } from 'common/models/flow/Team';

import { BusinessUnitId } from 'common/models/flow/BusinessUnits';
import { Distributor } from 'common/models/flow/Distributor';
import { CityId } from 'common/models/flow/CityId';

class InternalTeam extends Team {
    static fromJS(json: TeamModelType): InternalTeam {
        const state: Object = Object.assign({}, json);
        state.businessUnitId = state.businessUnitId
            ? BusinessUnitId.fromJS(state.businessUnitId)
            : state.businessUnitId;
        state.distributor = state.distributor
            ? Distributor.fromJS(state.distributor)
            : state.distributor;
        state.cityId = state.cityId
            ? CityId.fromJS(state.cityId)
            : state.cityId;
        return new this(Immutable.Map(state));
    }

    equals(other: Team): boolean {
        if (this.clientId !== other.clientId) {
            return false;
        } else if (this.teamId !== other.teamId) {
            return false;
        } else if (this.color !== other.color) {
            return false;
        } else if (this.description !== other.description) {
            return false;
        } else if (this.name !== other.name) {
            return false;
        }
        return true;
    }

    get distributor(): ?Distributor {
        return this._state.get('distributor');
    }

    get businessUnitId(): ?BusinessUnitId {
        return this._state.get('businessUnitId');
    }

    get cityId(): ?CityId {
        return this._state.get('cityId');
    }
}

export { InternalTeam as Team };
